import { Stack, Typography } from "@mui/material";
import IconLoader from "../IconLoader";
import { convertPxToRem } from "@/utils";
import theme from "@/theme";
import { useTranslation } from "react-i18next";
import Panel from "../Panel";

interface InfoContextPanelProps {
  text: string;
  title: string;
  icon?: string;
  compact?: boolean;
  compactIcon?: string;
  compactText?: string;
}

export default function InfoContextPanel({
  text,
  compact = false,
  icon = "UserIcon",
  title,
  compactIcon = "UserIcon",
  compactText,
}: InfoContextPanelProps) {
  const { t } = useTranslation();

  return (
    <Panel
      role="article"
      sx={{
        display: "flex",
        gap: 1,
        padding: compact ? 1 : 2,
        flexDirection: "row",
        backgroundColor: theme.palette.primary[100],
        borderRadius: 2,
        width: compact ? "fit-content" : "auto",
        boxShadow: "none",
      }}
      aria-label={
        compact
          ? t("SelectedDependantPanel.ariaLabel.compact")
          : t("SelectedDependantPanel.title")
      }
    >
      <Stack alignSelf="center">
        <IconLoader
          icon={compact ? compactIcon : icon}
          sx={{
            fontSize: convertPxToRem(compact ? 16 : 34),
            color: compact
              ? theme.palette.neutral.main
              : theme.palette.primary.main,
          }}
        />
      </Stack>
      <Stack alignSelf="center">
        {compact === false && <Typography variant="body2">{title}</Typography>}
        <Typography variant={compact ? "body2" : "body1"} fontWeight="bold">
          {compact ? compactText : text}
        </Typography>
      </Stack>
    </Panel>
  );
}
